var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFirefox = function SvgFirefox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7511 8.0495C22.2471 6.83371 21.2256 5.52115 20.4238 5.10653C21.0764 6.38909 21.4539 7.67552 21.5983 8.63539C21.5983 8.63539 21.5983 8.64216 21.6007 8.65474C20.2891 5.37746 18.0646 4.05571 16.248 1.17854C16.1558 1.0334 16.0641 0.888259 15.9743 0.732958C15.9236 0.64539 15.8826 0.566047 15.8469 0.491057C15.7716 0.345579 15.7134 0.191828 15.6736 0.0328964C15.6739 0.0253491 15.6714 0.0179533 15.6666 0.012143C15.6618 0.00633261 15.655 0.00252172 15.6475 0.00144922C15.6404 -0.000483074 15.6329 -0.000483074 15.6258 0.00144922C15.6239 0.00232536 15.6221 0.0034652 15.6205 0.00483584C15.6176 0.00483584 15.6147 0.00822246 15.6118 0.00919006L15.6166 0.00290063C12.7023 1.71363 11.7136 4.87818 11.6229 6.46166C10.4583 6.54148 9.34478 6.97124 8.4276 7.69488C8.33173 7.61363 8.23149 7.53772 8.12733 7.46749C7.86302 6.54017 7.85185 5.55875 8.09499 4.62563C6.9031 5.16991 5.97623 6.02866 5.30232 6.78871H5.29701C4.83695 6.20476 4.8693 4.27875 4.89537 3.87671C4.89006 3.85155 4.55262 4.05233 4.50917 4.08281C4.10322 4.37305 3.72374 4.69879 3.37521 5.05622C2.97859 5.45921 2.61624 5.8947 2.29193 6.35813C1.54581 7.41785 1.01666 8.61527 0.735087 9.88118C0.729776 9.90634 0.724949 9.93246 0.719639 9.9581C0.697915 10.0602 0.619228 10.5725 0.605229 10.6838V10.7094C0.502649 11.2388 0.438757 11.775 0.414062 12.3137V12.3732C0.414062 18.7943 5.60838 24 12.0153 24C17.7537 24 22.5179 19.8248 23.451 14.3404C23.4704 14.1919 23.4863 14.0419 23.5037 13.8919C23.7344 11.8977 23.4781 9.80184 22.7511 8.0495ZM9.37908 17.1508C9.43315 17.1764 9.48432 17.205 9.53984 17.2301L9.54756 17.235C9.49205 17.2079 9.43556 17.1798 9.37957 17.1508H9.37908ZM21.6017 8.66006V8.64893V8.66151V8.66006Z",
    fill: "url(#firefox_svg__paint0_linear_20_7665)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7506 8.04954C22.2466 6.83374 21.2251 5.52119 20.4233 5.10657C21.076 6.38913 21.4535 7.67556 21.5978 8.63542V8.65913C22.6927 11.6335 22.096 14.6583 21.2367 16.5064C19.9072 19.3657 16.6888 22.2965 11.6504 22.1538C6.21133 21.999 1.41625 17.9491 0.52076 12.649C0.357593 11.8126 0.52076 11.3883 0.602826 10.7095C0.502898 11.2325 0.464762 11.3839 0.415039 12.3138V12.3733C0.415039 18.7943 5.60935 24 12.0163 24C17.7547 24 22.5189 19.8248 23.452 14.3404C23.4713 14.1919 23.4873 14.0419 23.5046 13.8919C23.7339 11.8977 23.4776 9.80187 22.7506 8.04954Z",
    fill: "url(#firefox_svg__paint1_radial_20_7665)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7506 8.04954C22.2466 6.83374 21.2251 5.52119 20.4233 5.10657C21.076 6.38913 21.4535 7.67556 21.5978 8.63542V8.65913C22.6927 11.6335 22.096 14.6583 21.2367 16.5064C19.9072 19.3657 16.6888 22.2965 11.6504 22.1538C6.21133 21.999 1.41625 17.9491 0.52076 12.649C0.357593 11.8126 0.52076 11.3883 0.602826 10.7095C0.502898 11.2325 0.464762 11.3839 0.415039 12.3138V12.3733C0.415039 18.7943 5.60935 24 12.0163 24C17.7547 24 22.5189 19.8248 23.452 14.3404C23.4713 14.1919 23.4873 14.0419 23.5046 13.8919C23.7339 11.8977 23.4776 9.80187 22.7506 8.04954Z",
    fill: "url(#firefox_svg__paint2_radial_20_7665)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1128 9.41579C17.1384 9.43369 17.1611 9.45159 17.1852 9.46949C16.894 8.95137 16.5313 8.47707 16.1077 8.06066C12.5016 4.44666 15.1625 0.224027 15.611 0.00921912L15.6158 0.00292969C12.7015 1.71365 11.7128 4.87821 11.6221 6.46169C11.7572 6.4525 11.8919 6.44089 12.0295 6.44089C14.2043 6.44089 16.0985 7.63975 17.1128 9.41579Z",
    fill: "url(#firefox_svg__paint3_radial_20_7665)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0372 10.1376C12.0183 10.4279 10.9988 11.4246 10.642 11.4246C7.34298 11.4246 6.80762 13.4246 6.80762 13.4246C6.95244 15.1092 8.12357 16.4963 9.54043 17.2302C9.60511 17.2636 9.67028 17.2936 9.73352 17.3236C9.84697 17.3719 9.96089 17.4203 10.0743 17.4634C10.5602 17.6351 11.0691 17.733 11.5839 17.7537C17.3662 18.0256 18.4871 10.8246 14.3138 8.73364C15.3821 8.54738 16.4914 8.97845 17.1108 9.41435C16.097 7.63831 14.2023 6.43945 12.0275 6.43945C11.8899 6.43945 11.7553 6.45106 11.6201 6.46026C10.4564 6.54106 9.34391 6.97131 8.4277 7.69492C8.60487 7.84538 8.80473 8.04568 9.22519 8.46078C10.014 9.24067 12.0328 10.0433 12.0372 10.1376Z",
    fill: "url(#firefox_svg__paint4_radial_20_7665)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0372 10.1376C12.0183 10.4279 10.9988 11.4246 10.642 11.4246C7.34298 11.4246 6.80762 13.4246 6.80762 13.4246C6.95244 15.1092 8.12357 16.4963 9.54043 17.2302C9.60511 17.2636 9.67028 17.2936 9.73352 17.3236C9.84697 17.3719 9.96089 17.4203 10.0743 17.4634C10.5602 17.6351 11.0691 17.733 11.5839 17.7537C17.3662 18.0256 18.4871 10.8246 14.3138 8.73364C15.3821 8.54738 16.4914 8.97845 17.1108 9.41435C16.097 7.63831 14.2023 6.43945 12.0275 6.43945C11.8899 6.43945 11.7553 6.45106 11.6201 6.46026C10.4564 6.54106 9.34391 6.97131 8.4277 7.69492C8.60487 7.84538 8.80473 8.04568 9.22519 8.46078C10.014 9.24067 12.0328 10.0433 12.0372 10.1376Z",
    fill: "url(#firefox_svg__paint5_radial_20_7665)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88833 7.30836C7.98246 7.36931 8.0597 7.4206 8.1297 7.46753C7.86538 6.54021 7.85422 5.55879 8.09736 4.62567C6.90546 5.16995 5.9786 6.0287 5.30469 6.78875C5.35924 6.7873 7.04208 6.75682 7.88833 7.30836Z",
    fill: "url(#firefox_svg__paint6_radial_20_7665)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.521267 12.649C1.41676 17.9491 6.21184 21.999 11.6548 22.1538C16.6932 22.2965 19.9097 19.3656 21.2411 16.5064C22.1004 14.6578 22.697 11.6335 21.6022 8.6591V8.63684C21.6022 8.63975 21.6022 8.64362 21.6046 8.6562C22.0159 11.3495 20.6492 13.9587 18.5126 15.7231C18.5104 15.728 18.5083 15.733 18.5063 15.7381C14.3427 19.1358 10.3586 17.788 9.55194 17.2379C9.49594 17.2108 9.43946 17.1827 9.38346 17.1537C6.95575 15.9926 5.95309 13.7743 6.16791 11.8735C4.11867 11.8735 3.41966 10.1405 3.41966 10.1405C3.41966 10.1405 5.25987 8.82553 7.68517 9.96924C9.93138 11.0288 12.041 10.141 12.041 10.1405C12.0366 10.0462 10.0178 9.24111 9.23043 8.46364C8.80997 8.04854 8.61011 7.84825 8.43294 7.69778C8.33708 7.61654 8.23684 7.54063 8.13268 7.4704C8.06364 7.42202 7.98785 7.37364 7.8913 7.31123C7.04506 6.75969 5.36221 6.79017 5.3067 6.79162H5.30139C4.84133 6.20767 4.87368 4.28166 4.89975 3.87962C4.89444 3.85446 4.557 4.05524 4.51355 4.08572C4.1076 4.37596 3.72812 4.7017 3.37959 5.05913C2.98297 5.46212 2.62062 5.89761 2.29631 6.36104C1.55019 7.42076 1.02104 8.61818 0.739467 9.88409C0.730295 9.90634 0.317549 11.7124 0.521267 12.649Z",
    fill: "url(#firefox_svg__paint7_radial_20_7665)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1076 8.06063C16.5312 8.47704 16.8939 8.95134 17.1851 9.46946C17.2454 9.51488 17.3034 9.56332 17.3589 9.6146C19.9889 12.0414 18.613 15.4768 18.5083 15.7236C20.6449 13.9592 22.0115 11.35 21.6002 8.65667C20.2886 5.37746 18.0642 4.05571 16.2476 1.17854C16.1554 1.0334 16.0637 0.888259 15.9739 0.732958C15.9232 0.64539 15.8822 0.566047 15.8464 0.491057C15.7712 0.345579 15.713 0.191828 15.6731 0.0328964C15.6734 0.0253491 15.671 0.0179533 15.6661 0.012143C15.6613 0.00633261 15.6545 0.00252172 15.6471 0.00144922C15.6399 -0.000483074 15.6324 -0.000483074 15.6253 0.00144922C15.6234 0.00232536 15.6216 0.0034652 15.62 0.00483584C15.6171 0.00483584 15.6142 0.00822246 15.6113 0.00919006C15.1624 0.223998 12.5015 4.44663 16.1076 8.06063Z",
    fill: "url(#firefox_svg__paint8_radial_20_7665)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3576 9.61216C17.3021 9.56088 17.2441 9.51243 17.1838 9.46702C17.1601 9.44912 17.1355 9.43122 17.1114 9.41332C16.492 8.9779 15.3827 8.54635 14.3144 8.73261C18.4872 10.8236 17.3668 18.0245 11.5845 17.7526C11.0696 17.7319 10.5608 17.6341 10.0749 17.4623C9.96148 17.4198 9.84756 17.3728 9.73411 17.3225C9.66846 17.2925 9.60329 17.2625 9.54102 17.2291L9.54874 17.234C10.3554 17.7855 14.3395 19.1334 18.5031 15.7342C18.5031 15.7342 18.5055 15.7279 18.5094 15.7192C18.6127 15.4768 19.9885 12.0413 17.3576 9.61216Z",
    fill: "url(#firefox_svg__paint9_radial_20_7665)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80679 13.4246C6.80679 13.4246 7.34215 11.4246 10.6412 11.4246C10.998 11.4246 12.0175 10.427 12.0363 10.1376C12.0552 9.84833 9.92676 11.0259 7.68056 9.96638C5.25526 8.82267 3.41504 10.1376 3.41504 10.1376C3.41504 10.1376 4.11405 11.8706 6.1633 11.8706C5.94847 13.7715 6.95113 15.9878 9.37885 17.1508C9.43291 17.1765 9.48408 17.205 9.5396 17.2302C8.12275 16.4977 6.95306 15.1092 6.80679 13.4246Z",
    fill: "url(#firefox_svg__paint10_radial_20_7665)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7511 8.0495C22.2471 6.83371 21.2256 5.52115 20.4238 5.10653C21.0764 6.38909 21.4539 7.67552 21.5983 8.63539C21.5983 8.63539 21.5983 8.64216 21.6007 8.65474C20.2891 5.37746 18.0646 4.05571 16.248 1.17854C16.1558 1.0334 16.0641 0.888259 15.9743 0.732958C15.9236 0.64539 15.8826 0.566047 15.8469 0.491057C15.7716 0.345579 15.7134 0.191828 15.6736 0.0328964C15.6739 0.0253491 15.6714 0.0179533 15.6666 0.012143C15.6618 0.00633261 15.655 0.00252172 15.6475 0.00144922C15.6404 -0.000483074 15.6329 -0.000483074 15.6258 0.00144922C15.6239 0.00232536 15.6221 0.0034652 15.6205 0.00483584C15.6176 0.00483584 15.6147 0.00822246 15.6118 0.00919006L15.6166 0.00290063C12.7023 1.71363 11.7136 4.87818 11.6229 6.46166C11.758 6.45247 11.8927 6.44086 12.0303 6.44086C14.2051 6.44086 16.0993 7.63972 17.1136 9.41576C16.4942 8.98034 15.3849 8.54879 14.3166 8.73505C18.4894 10.826 17.369 18.027 11.5867 17.7551C11.0718 17.7344 10.563 17.6365 10.0771 17.4648C9.96369 17.4222 9.84976 17.3753 9.73631 17.325C9.67066 17.295 9.60549 17.265 9.54322 17.2316L9.55094 17.2364C9.49494 17.2093 9.43846 17.1813 9.38246 17.1522C9.43653 17.1779 9.4877 17.2064 9.54322 17.2316C8.12347 16.4977 6.95378 15.1091 6.80751 13.4245C6.80751 13.4245 7.34287 11.4245 10.6419 11.4245C10.9987 11.4245 12.0182 10.4269 12.0371 10.1376C12.0327 10.0433 10.0139 9.2382 9.22654 8.46073C8.80607 8.04563 8.60621 7.84534 8.42905 7.69488C8.33318 7.61363 8.23294 7.53772 8.12878 7.46749C7.86446 6.54017 7.85329 5.55875 8.09644 4.62563C6.90454 5.16991 5.97768 6.02866 5.30377 6.78871H5.29846C4.8384 6.20476 4.87075 4.27875 4.89681 3.87671C4.8915 3.85155 4.55407 4.05233 4.51062 4.08281C4.10467 4.37305 3.72519 4.69879 3.37666 5.05622C2.98004 5.45921 2.61769 5.8947 2.29338 6.35813C1.54725 7.41785 1.01811 8.61527 0.736535 9.88118C0.731225 9.90634 0.726397 9.93246 0.721087 9.9581C0.699364 10.0602 0.600884 10.5798 0.587367 10.6911C0.587367 10.6828 0.587367 10.6998 0.587367 10.6911C0.496978 11.228 0.439103 11.7698 0.414062 12.3137V12.3732C0.414062 18.7943 5.60838 24 12.0153 24C17.7537 24 22.5179 19.8248 23.451 14.3404C23.4704 14.1919 23.4863 14.0419 23.5037 13.8919C23.7344 11.8977 23.4781 9.80184 22.7511 8.0495ZM21.6002 8.64651V8.65909V8.64651Z",
    fill: "url(#firefox_svg__paint11_linear_20_7665)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "firefox_svg__paint0_linear_20_7665",
    x1: 21.2155,
    y1: 3.71802,
    x2: 1.91524,
    y2: 22.2983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox_svg__paint1_radial_20_7665",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.3248 2.66385) scale(24.1859 24.239)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FFBD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFAC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FF9D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF563B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FF3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F5156C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#EB0878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#E50080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox_svg__paint2_radial_20_7665",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.4872 12.5731) scale(24.1859 24.239)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#960E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#B11927",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DB293D",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F5334B",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox_svg__paint3_radial_20_7665",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.4036 -2.83699) scale(17.5216 17.5601)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFDC3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FF9D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox_svg__paint4_radial_20_7665",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.81293 18.9046) scale(11.5158 11.5411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3A8EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#5C79F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#9059FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C139E6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox_svg__paint5_radial_20_7665",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.8352 9.69238) rotate(-13.9265) scale(6.10193 7.18222)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#9059FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#8C4FF3",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#7716A8",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#6E008B",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox_svg__paint6_radial_20_7665",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.1821 1.67206) scale(8.28484 8.30302)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFDB27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFC82A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFA930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FF7E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FF7139"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox_svg__paint7_radial_20_7665",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.6944 -3.59416) scale(35.3469 35.4245)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox_svg__paint8_radial_20_7665",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.2772 0.276201) rotate(84.2447) scale(25.8204 16.9277)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox_svg__paint9_radial_20_7665",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.9863 4.74705) scale(22.0671 22.1156)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox_svg__paint10_radial_20_7665",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.8116 6.04178) scale(24.1526 24.2056)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FFE141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFAF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "firefox_svg__paint11_linear_20_7665",
    x1: 20.9837,
    y1: 3.61836,
    x2: 4.56063,
    y2: 20.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFF44F",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FFF44F",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFF44F",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFF44F",
    stopOpacity: 0
  })))));
};
export default SvgFirefox;